export default "__VITE_ASSET__DCNrr6wd__"